<template>
  <b-row>
    <b-col md="12">
      <hr />
      <h6 class="pack-name">{{pack.name}}</h6>
      <div class="table-responsive">
        <table class="table table-sm table-hover">
          <thead class="t-head thead-light">
            <td v-translate>Room type</td>
            <td style="width:5px">&nbsp;</td>
            <td v-translate>Meal</td>
            <td v-translate>Booking price</td>
            <td v-translate>Sale</td>
            <td></td>
            <td v-translate>Availability</td>
            <td>&nbsp;</td>
          </thead>
          <tbody>
            <category
              v-for="(category, categoryIndex) in pack.categories"
              :categoryIndex="categoryIndex"
              :resultIndex="resultIndex"
              :category="category"
              :currency="currency"
              :key="'c' + categoryIndex"
              @book="$emit('book',{ categoryId: category.id, ...$event })"
              @priceDetails="$emit('priceDetails', {category, ...$event})"
            />
          </tbody>
        </table>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import category from '@/app/private/shared/components/category_result'

export default {
  props: ['pack', 'packageIndex', 'currency', 'resultIndex'],
  components: { category }
}
</script>
